import React, { useEffect, useRef, useState } from 'react';
import { Modal, Button } from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { logoutAction } from '../../modules/actions/LogoutAction';

const IDLE_TIMEOUT = 10 * 60 * 1000; // 10 minutes (600,000 ms)
const WARNING_DURATION = 30 * 1000;   // 30 seconds (30,000 ms)

const IdleTimeout = ({ onLogout, navigate }) => {
  const [showWarning, setShowWarning] = useState(false);
  const [secondsLeft, setSecondsLeft] = useState(Math.floor(WARNING_DURATION / 1000));
  const [sessionExpired, setSessionExpired] = useState(false);
  const idleTimer = useRef(null);
  const warningInterval = useRef(null);

  const resetIdleTimer = () => {
    clearTimeout(idleTimer.current);
    clearInterval(warningInterval.current);
    setShowWarning(false);
    setSecondsLeft(Math.floor(WARNING_DURATION / 1000));

    idleTimer.current = setTimeout(() => {
      setShowWarning(true);
      setSecondsLeft(Math.floor(WARNING_DURATION / 1000));

      warningInterval.current = setInterval(() => {
        setSecondsLeft(prev => {
          if (prev <= 1) {
            clearInterval(warningInterval.current);
            setSessionExpired(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }, IDLE_TIMEOUT);
  };

  useEffect(() => {
    const events = ['mousemove', 'keydown', 'mousedown', 'touchstart', 'scroll'];
    events.forEach(event => window.addEventListener(event, resetIdleTimer));
    resetIdleTimer();

    return () => {
      events.forEach(event => window.removeEventListener(event, resetIdleTimer));
      clearTimeout(idleTimer.current);
      clearInterval(warningInterval.current);
    };
  }, []);

  useEffect(() => {
    if (sessionExpired) {
      onLogout?.();
      localStorage.clear();
      sessionStorage.clear();
      navigate?.('/login');
    }
  }, [sessionExpired, onLogout, navigate]);

  const handleContinue = () => {
    resetIdleTimer();
    setShowWarning(false);
  };

  return (
    <Modal
      open={showWarning}
      title="Session Expiring Soon"
      closable={false}
      footer={[
        <Button key="continue" type="primary" onClick={handleContinue}>
          Continue Session
        </Button>
      ]}
    >
      <p>Your session will expire in <b>{secondsLeft}</b> seconds due to inactivity.</p>
      <p>Click &quot;Continue Session&quot; to stay logged in.</p>
    </Modal>
  );
};

const mapDispatchToProps = (dispatch) => ({
  onLogout: bindActionCreators(logoutAction, dispatch)
});

export default connect(null, mapDispatchToProps)(IdleTimeout);
